import { useEffect, useState } from 'react';

function getValueFromLocalStorage(flagKey: string) {
  try {
    const cachedValue = localStorage.getItem(flagKey) ?? '';
    const parsedValue = JSON.parse(cachedValue);

    if (typeof parsedValue === 'boolean') {
      return parsedValue;
    }
  } catch {
    return null;
  }

  return null;
}

export function useCachedFlag(flagKey: string, defaultValue: boolean) {
  const [flag, setFlag] = useState(() => getValueFromLocalStorage(flagKey) ?? defaultValue);

  useEffect(() => {
    localStorage.setItem(flagKey, JSON.stringify(flag));
  }, [flag, flagKey]);

  return [flag, setFlag] as const;
}
